<template>
    <header class="sticky transition-all duration-300 z-50 top-0" data-scroll-direction>
        <div data-menu="top" class="bg-leonard-green h-16 place-content-center">
            <div class="container mx-auto grid grid-cols-[1fr_auto] items-center px-3 lg:px-4">
                <SocialMedia/>
                <nav class="hidden 2xl:block">
                    <ul class="flex flex-row space-x-2 sm:space-x-3 lg:space-x-6">
                        <li class="relative flex items-center group flex-row">
                            <a class="py-1.5 whitespace-nowrap text-leonard-white hover:text-leonard-white-hover opacity-100"
                               title="FAQ Page" href="https://www.leonards.com/faq" target="_blank">
                                FAQ
                            </a>
                        </li>
                        <li class="relative flex items-center group flex-row">
                            <a class="py-1.5 whitespace-nowrap text-leonard-white hover:text-leonard-white-hover opacity-100"
                               title="Contact Us Page" href="https://www.leonards.com/contact" target="_blank">
                                Contact Us
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div data-menu-overlay class="fixed inset-0 bg-leonard-black-transparent bg-opacity-50 z-40 transition-opacity duration-300 opacity-0 pointer-events-none" @click="toggleMenu()"></div>
        <div data-hamburger-menu class="grid grid-rows-[auto_1fr_auto] fixed top-0 left-0 w-full h-full bg-leonard-white transform transition-all duration-300 ease-in-out z-50 md:max-w-[360px] -translate-x-full">
            <div class="grid h-[170px] bg-leonard-green place-items-center">
                <a href="https://www.leonards.com" class="text-leonard-white" target="_blank" title="Leonard's Studio">
                    <Logo class="h-16 w-auto"></Logo>
                </a>
            </div>
            <nav class="p-4 overflow-y-auto">
                <ul class="flex flex-col">
                    <li class="relative items-center group">
                        <router-link
                            :to="{name: 'order'}"
                            class="py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover"
                            active-class="text-leonard-green hover:!text-leonard-green"
                        >
                            Order Photos
                        </router-link>
                    </li>
                    <li class="relative items-center group" v-if="loggedIn() && isEmployee">
                        <button type="button" aria-label="User Dropdown Menu" @click.prevent="toggleDropdown('employee')"
                                class="grid grid-cols-[1fr_auto] justify-between w-full py-1.5 whitespace-nowrap text-left text-leonard-black hover:text-leonard-green-hover"
                        >
                            Employees &amp; Officers
                            <ChevronDown class="text-leonard-black group-hover:text-leonard-green-hover ms-1 w-4"/>
                        </button>
                        <ul class="py-2 px-4 rounded group-hover:block bg-leonard-grey"
                            :class="{'dropdown-open': dropdown === 'employee'}"
                            v-show="dropdown === 'employee'"
                        >
                            <li class="relative flex items-center group flex-row">
                                <a class="grid grid-cols-[1fr_auto] justify-between items-center w-full py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover opacity-100"
                                   target="_blank" rel="noopener noreferrer" title="School Administrative Portal"
                                   href="https://schooladmin.leonards.com/login">
                                    School Administrative Portal
                                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link ml-6">
                                        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                                        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="relative flex items-center group flex-row">
                        <a class="py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover"
                           title="FAQ Page" href="https://www.leonards.com/faq" target="_blank">
                            FAQ
                        </a>
                    </li>
                    <li class="relative flex items-center group flex-row">
                        <a class="py-1.5 whitespace-nowrap text-leonard-black hover:text-leonard-green-hover"
                           title="Contact Us Page" href="https://www.leonards.com/contact" target="_blank">
                            Contact Us
                        </a>
                    </li>
                </ul>
            </nav>
            <nav class="p-4">
                <button type="button"
                        class="transition duration-300 py-2 px-3 md:px-4 rounded-md border-2 font-medium text-sm md:text-base w-full bg-leonard-black border-transparent text-leonard-white hover:bg-leonard-black-hover focus:ring-leonard-black cursor-pointer mt-2"
                        aria-label="Close Menu"
                        @click="toggleMenu()">
                    Close Menu
                </button>
            </nav>
        </div>
        <div data-menu="main" class="bg-leonard-white">
            <div class="container mx-auto grid grid-cols-[auto_auto_1fr] gap-x-1 sm:gap-x-4 lg:gap-x-6 items-center p-3 md:p-4">
                <button type="button" class="block 2xl:hidden p-2" @click="toggleMenu()">
                    <Bars class="h-6 w-6 text-leonard-black"></Bars>
                </button>

                <a href="https://www.leonards.com" class="text-leonard-green" target="_blank" title="Leonard's Studio">
                    <Logo class="h-10 w-auto sm:h-12"></Logo>
                </a>

                <MainNavigationLeft></MainNavigationLeft>
                <MainNavigationRight></MainNavigationRight>
            </div>
        </div>
    </header>
</template>

<script>
import Logo from '../icons/Logo.vue';
import SocialMedia from "../partials/SocialMedia.vue";
import MainNavigationLeft from "../partials/MainNavigationLeft.vue";
import MainNavigationRight from "../partials/MainNavigationRight.vue";
import Bars from "../icons/Bars.vue";
import ChevronDown from "../icons/ChevronDown.vue";

export default {
    data() {
        return {
            isOpen: false,
            dropdown: ''
        }
    },

    components: {
        ChevronDown,
        Bars,
        MainNavigationRight,
        MainNavigationLeft,
        SocialMedia,
        Logo
    },

    mounted() {
        const self = this;
        this.$router.beforeEach((to, from, next) => {
            self.dropdown = '';

            if (self.isOpen) {
                self.toggleMenu();
            }

            next();
        });
    },

    methods: {
        toggleDropdown(name) {
            this.dropdown = this.dropdown === name ? '' : name;
        },
        toggleMenu() {
            self.dropdown = '';
            this.isOpen = !this.isOpen;
            document.body.classList.toggle('no-scroll', this.isOpen);

            const menuOverlay = document.querySelector('[data-menu-overlay]');
            const hamburgerMenu = document.querySelector('[data-hamburger-menu]');

            if (menuOverlay) {
                menuOverlay.classList.toggle('opacity-100', this.isOpen);
                menuOverlay.classList.toggle('pointer-events-auto', this.isOpen);
            }

            if (hamburgerMenu) {
                hamburgerMenu.classList.toggle('translate-x-0', this.isOpen);
                hamburgerMenu.classList.toggle('hamburger-menu-shadow', this.isOpen);
                hamburgerMenu.classList.toggle('-translate-x-full', !this.isOpen);
            }
        }
    },
}
</script>
